(function () {
  const ROOT_SELECTOR = '#pc--optOutFormContainer';

  function enhanceField(field) {
    if (!field || field.dataset.enhanced === 'true') return;

    const input = field.querySelector('input');
    if (!input) return;

    field.dataset.enhanced = 'true';

    const syncActiveState = () => {
      field.classList.toggle('is-active', input.value.trim().length > 0);
    };

    input.addEventListener('input', syncActiveState);
    input.addEventListener('change', syncActiveState);
    input.addEventListener('focus', () => field.classList.add('is-active'));
    input.addEventListener('blur', syncActiveState);
    syncActiveState();
  }

  function enhanceCheckbox(root) {
    const checkbox = root.querySelector('#pc--show-email-field');
    if (!checkbox || checkbox.dataset.enhanced === 'true') return;

    checkbox.dataset.enhanced = 'true';

    checkbox.addEventListener('change', () => {
      if (!checkbox.checked) return;

      const emailInput = root.querySelector('#pc--opt-out-email_input');
      const emailField = emailInput?.closest('.pc--opt-out-form-field');
      if (!emailInput) return;

      // Shopify's handler focuses the email input on check; defer blur so the label stays visible.
      setTimeout(() => {
        emailInput.blur();
        if (emailField && !emailInput.value.trim()) {
          emailField.classList.remove('is-active');
        }
      }, 0);
    });
  }

  function enhanceForm(root) {
    root.querySelectorAll('.pc--opt-out-form-field').forEach(enhanceField);
    enhanceCheckbox(root);
  }

  function init() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    enhanceForm(root);

    const observer = new MutationObserver(() => enhanceForm(root));
    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
